import React from 'react';
import { Grid, TextField, Button, Box, Typography, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { doctorGroups } from '../constants/options';

const SignatureField = ({ label, name, value, dateValue, onSign, onNameChange, nameValue, signName, isDoctor = false, onChange }) => (
  <Box sx={{ p: 2, border: '1px solid #eee', borderRadius: 2, height: '100%' }}>
    <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 1, color: '#008080' }}>
      {label}
    </Typography>
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      {isDoctor ? (
        <FormControl fullWidth size="small">
          <InputLabel>{`Name (${label})`}</InputLabel>
          <Select
            name={signName}
            value={nameValue || ''}
            onChange={onChange}
            label={`Name (${label})`}
          >
            <MenuItem value=""><em>Select Doctor</em></MenuItem>
            {doctorGroups["AnaesthesiaSpecialists"]?.map((doctor, idx) => (
              <MenuItem key={idx} value={doctor}>{doctor}</MenuItem>
            ))}
          </Select>
        </FormControl>
      ) : (
        onNameChange && (
          <TextField
            label={`Full Name`}
            name={signName}
            value={nameValue || ''}
            onChange={onNameChange}
            size="small"
            fullWidth
          />
        )
      )}
      <Button
        variant="outlined"
        onClick={() => onSign(name)}
        sx={{ color: '#008080', borderColor: '#008080' }}
      >
        {value ? 'Update Signature' : 'Provide Signature'}
      </Button>
      {value && (
        <Box sx={{ border: '1px solid #ccc', p: 1, borderRadius: 1, textAlign: 'center' }}>
          <img
            src={`data:image/png;base64,${value}`}
            alt={`${label} Signature`}
            style={{ maxHeight: '60px', maxWidth: '100%' }}
          />
        </Box>
      )}
      <TextField
        label="Date & Time"
        type="datetime-local"
        value={dateValue || ''}
        InputLabelProps={{ shrink: true }}
        size="small"
        fullWidth
        InputProps={{ readOnly: true }}
      />
    </Box>
  </Box>
);

const ConsentSignaturesSection = ({ formData, handleSignatureOpen, handleNameChange, handleChange }) => {
  return (
    <Box sx={{ mt: 4 }}>
      <Typography variant="h6" sx={{ color: '#008080', mb: 2, fontWeight: 'bold', borderBottom: '2px solid #008080' }}>
        Step 1: Patient's Consent & Signatures
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <SignatureField
            label="Patient"
            name="patient_signature"
            value={formData.patient_signature}
            nameValue={formData.patient_signature_name}
            dateValue={formData.patient_signature_date_time}
            onSign={handleSignatureOpen}
            onNameChange={handleNameChange}
            signName="patient_signature_name"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <SignatureField
            label="Witness"
            name="witness_signature"
            value={formData.witness_signature}
            nameValue={formData.witness_name}
            dateValue={formData.witness_signature_date_time}
            onSign={handleSignatureOpen}
            onNameChange={handleNameChange}
            signName="witness_name"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <SignatureField
            label="Doctor/Anaesthetist"
            name="doctor_anaesthetist_signature"
            value={formData.doctor_anaesthetist_signature}
            nameValue={formData.doctor_anaesthetist_name}
            dateValue={formData.doctor_anaesthetist_signature_date_time}
            onSign={handleSignatureOpen}
            signName="doctor_anaesthetist_name"
            isDoctor={true}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <SignatureField
            label="Interpreter (if applicable)"
            name="interpreter_signature"
            value={formData.interpreter_signature}
            nameValue={formData.interpreter_name}
            dateValue={formData.interpreter_signature_date_time}
            onSign={handleSignatureOpen}
            onNameChange={handleNameChange}
            signName="interpreter_name"
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default ConsentSignaturesSection;
